<template>
<vue-markdown>
这里介绍的是后台跟财务相关的一些逻辑。

#### 1. 统计图表
统计页面的图表提供的信息比较简洁直观， 注意使用


#### 2. 订单扣费规则

1. 订单拼板后会立即收取一笔费用
2. 一个订单多次拼板只会收取一次费用
3. 如果产生了售后，需要额外收取费用，请到订单页面点击`收取费用`按钮手动收取费用
4. 对于已经收取费用的订单，删除订单不会返还该费用

#### 3. 邮件通知
以下三种场景会有邮件通知：

1. 手动收取订单费用
2. 向公司账户充值
3. 修改产品价格

#### 4. 统计表格

统计页面和消费记录页面（公司->消费记录）都可以导出订单相关的表格，二者侧重点不同。

前者导出的是**订单信息**，删除的订单不论扣费与否，都会红色高亮显示。一个订单只有一条记录
后者导出的是**收费信息**，在什么时候对订单收取了多少费用。一个订单可能会有多个扣费记录


</vue-markdown>
</template>
<script>
import VueMarkdown from 'vue-markdown'

export default {
  name: 'help-search-orders',
  components: {
    'vue-markdown': VueMarkdown
  }
}
</script>